<div class="payment-container">
    <!-- Header -->
    <h2 class="payment-title">Secure Payment</h2>

    <!-- Amount Section -->
    <div class="amount-summary">
        <p>Total Rate: <b>{{ totalAmount | currency:'AED' }}</b></p>
        <p class="highlight">
            Platform Fee (0.1%): <span>{{ platformFee | currency:'AED' }}</span>
        </p>
        <p class="note">
            * You will only be charged the platform fee now. The remaining amount is to be paid directly to the
            vendor(s).
        </p>
    </div>

    <!-- Card Type Selection -->
    <div class="card-type-selection">
        <mat-radio-group [(ngModel)]="selectedCardType" color="primary">
            <mat-radio-button value="credit">Credit Card</mat-radio-button>
            <mat-radio-button value="debit">Debit Card</mat-radio-button>
        </mat-radio-group>
    </div>

    <!-- Credit Card Mock -->
    <div class="card-preview">
        <div class="chip"></div>
        <div class="card-details">
            <p class="card-number">**** **** **** 1234</p>
            <p class="card-name">JOHN DOE</p>
        </div>
    </div>

    <!-- Payment Form -->
    <form class="payment-form">
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Card Number</mat-label>
            <input matInput placeholder="XXXX XXXX XXXX XXXX" maxlength="19" />
        </mat-form-field>

        <div class="year">
            <mat-form-field appearance="outline" class="half-width">
                <mat-label>Expiry</mat-label>
                <input matInput placeholder="MM/YY" maxlength="5" />
            </mat-form-field>

            <mat-form-field appearance="outline" class="half-width">
                <mat-label>CVV</mat-label>
                <input matInput placeholder="123" maxlength="3" />
            </mat-form-field>
        </div>

        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Cardholder Name</mat-label>
            <input matInput placeholder="John Doe" />
        </mat-form-field>
    </form>

    <!-- Actions -->
    <div class="payment-actions">
        <button mat-stroked-button color="warn" (click)="onCancel()" [disabled]="processing">Cancel</button>
        <button mat-raised-button color="primary" (click)="onPay()" [disabled]="processing">
            {{ processing ? 'Processing...' : ('Pay ' + (platformFee | currency:'AED')) }}
        </button>
    </div>

    <p class="secure-text"><mat-icon>lock</mat-icon> Payment secured by AES 256-bit encryption</p>
</div>